const icons = {};
icons.block = <svg viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' fillRule='evenodd'
clipRule='evenodd' strokeLinejoin='round' strokeMiterlimit='1.414'>
    <g fill='#179cd4' fillRule='nonzero'>
        <path d='M42.82,13.431l-37.64,0c-2.742,0.003 -4.998,2.259 -5.001,5.001l0,11.136c0.003,2.742 2.259,4.998 5.001,5.001l37.64,0c2.742,-0.003 4.998,-2.259 5.001,-5.001l0,-11.136c-0.003,-2.742 -2.259,-4.998 -5.001,-5.001Zm3.204,5.001l0,8.687c-0.003,1.757 -1.448,3.201 -3.204,3.204l-37.64,0c-1.756,-0.003 -3.201,-1.447 -3.204,-3.204l0,-8.687c0.003,-1.757 1.448,-3.201 3.204,-3.204l37.64,0c1.756,0.003 3.201,1.447 3.204,3.204Z'
        />
        <path d='M40.471,26.364l-32.942,0c-0.493,0 -0.898,0.406 -0.898,0.899c0,0.493 0.405,0.898 0.898,0.898l32.942,0c0.493,0 0.898,-0.405 0.898,-0.898c0,-0.493 -0.405,-0.899 -0.898,-0.899Z'
        />
    </g>
</svg>;
export default icons;
